module.exports = __webpack_public_path__ + "static/media/01(6).044b4e46.jpg";